import * as types from '../reducer';
import Service from './service';

const loginVerify = () => async dispatch => {
  dispatch({ type: types.LOGIN_START });
  let token = localStorage.getItem('session-token');
  let usrid = localStorage.getItem('session-usrid');
  if(!token || !usrid || token === "undefined" || usrid === "undefined") {
    dispatch({ type: types.LOGIN_CLEAR });
    return false
  }
  const payload = await Service.verify({token});
  if(payload.user) {
    dispatch({ type: types.LOGIN_SESSION, payload });
  } else {
    dispatch({ type: types.LOGIN_CLEAR });
  }
}

export default loginVerify